// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"915":"7deb606e","3025":"07b6108d","3063":"609637eb","5538":"195f0225","6536":"5eab08c2","7656":"5f17e2e9","8200":"972fbea3","8716":"31d6cfe0","9778":"bb4c4bfe"}[chunkId] + ".chunk.css";
};